import React, { useCallback, useContext, useEffect, useState } from "react";
import Loader from "../../components/Loader";
import { Link, useNavigate } from "react-router-dom";
import { Grid2 } from "@mui/material";
import StyledGridComp from "../../components/StyledGridComp";
import { formatDate } from "../../utilities/helper";
import { fetchAllLotManagementDataService } from "../../services/lotManagementServices";
import { MenuContext } from "../../App";
import SearchedComponent from "../../components/SearchedComponent";
import useDebounceSearch from "../../hooks/useDebounceSearch";

const LotManagement = () => {
  const [load, setLoad] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [rowData, setRowData] = useState([]);
  const [rowLength, setRowLength] = useState(0);
  const [canAddLot, setCanAddLot] = useState(false);
  const [searchedValue, setSearchedValue] = useState("");
  const navigate = useNavigate();

  const debounceQuery = useDebounceSearch(searchedValue, 500);

  const { systemActions } = useContext(MenuContext);

  const access_token = localStorage?.getItem("access_token");
  const role = localStorage.getItem("role");

  useEffect(() => {
    if (page >= 0 && pageSize && access_token) {
      fetchAllLotManagementData(page, pageSize, access_token, debounceQuery);
    }
  }, [pageSize, page, debounceQuery]);

  useEffect(() => {
    if (systemActions?.length > 0 && role !== "Admin") {
      let canAdd = false;
      const createFound = systemActions?.find(
        (item) => item?.name === "CanCreateLotList",
      );
      if (createFound) {
        canAdd = true;
      }
      setCanAddLot(canAdd);
    } else if (role === "Admin") {
      setCanAddLot(true);
    }
  }, [systemActions]);

  const columns = [
    {
      field: "unblindedNumber",
      headerName: "Unblinded Lot Number",
      width: 330,
      renderHeader: () => (
        <div className="grid-heading">{"Unblinded Lot Number"}</div>
      ),
      renderCell: (params) => {
        const name = params.row.unblindedNumber;
        const id = params.row.id;

        return (
          <button
            className="bread-crumbs-link grid-nav-btn"
            onClick={() => {
              navigate("/addUpdate-lot-management", {
                state: {
                  id: id,
                },
              });
            }}
          >
            {name}
          </button>
        );
      },
    },
    {
      field: "blindedNumber",
      headerName: "Blinded Lot Number",
      width: 330,
      renderHeader: () => (
        <div className="grid-heading">{"Blinded Lot Number"}</div>
      ),
      renderCell: (params) => {
        const blindedNumber = params.row.blindedNumber;

        return <span className="data-font">{blindedNumber}</span>;
      },
    },
    {
      field: "expirationDate",
      headerName: "Expiration Date",
      width: 330,
      renderHeader: () => (
        <div className="grid-heading">{"Expiration Date"}</div>
      ),
      renderCell: (params) => {
        const expirationDate = params.row.expirationDate;
        return <span className="data-font">{formatDate(expirationDate)}</span>;
      },
    },
    {
      field: "stopShipmentDays",
      headerName: "Stop Shipment in Days",
      width: 330,
      renderHeader: () => (
        <div className="grid-heading">{"Stop Shipment in Days"}</div>
      ),
      renderCell: (params) => {
        const stopShipmentDays = params.row.stopShipmentDays;

        return <span className="data-font">{stopShipmentDays}</span>;
      },
    },
    {
      field: "doNotCountDays",
      headerName: "Do Not Count in Days",
      width: 330,
      renderHeader: () => (
        <div className="grid-heading">{"Do Not Count in Days"}</div>
      ),
      renderCell: (params) => {
        const doNotCountDays = params.row.doNotCountDays;

        return <span className="data-font">{doNotCountDays}</span>;
      },
    },

    // {
    //   field: "lastUpdate",
    //   headerName: "Last Updated",
    //   width: 200,
    //   renderHeader: () => <div className="grid-heading">{"Last Updated"}</div>,
    //   renderCell: (params) => {
    //     const lastUpdate = params.row.lastUpdate;
    //     return <span className="data-font">{formatDate(lastUpdate)}</span>;
    //   },
    // },
  ];

  const fetchAllLotManagementData = async (
    page,
    pageSize,
    access_Token,
    debouncedSearch = "",
  ) => {
    setLoad(true);
    try {
      const res = await fetchAllLotManagementDataService(
        page + 1,
        pageSize,
        access_Token,
        debouncedSearch,
      );
      if (res?.status === 200) {
        setRowData(res?.data?.result);
        setRowLength(res?.data?.totalCount);
        setLoad(false);
      } else if (res?.status == 401) {
        navigate("/unauthorize");
      }
    } catch (err) {
      setLoad(false);
      if (err?.status == 401) {
        navigate("/unauthorize");
      }
    }
  };

  const handleSearch = useCallback((e) => {
    setSearchedValue(e.target.value);
  }, []);

  return (
    <>
      <div className="content-body">
        <p
          className="bread-crumbs-link-container"
          style={{ fontWeight: "600" }}
        >
          <Link className="bread-crumbs-link" to="/">
            Home
          </Link>{" "}
          |{" "}
          <Link className="bread-crumbs-link" to="/lots-management">
            Lot Management
          </Link>
          -{" "}
          <b style={{ color: "gray" }}>{localStorage?.getItem("studyName")}</b>
        </p>
        <Grid2
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ width: "100%", margin: "0 auto" }}
        >
          <Grid2 item md={6}>
            <p className="page-heading">Lot Management</p>
          </Grid2>
          <Grid2 item md={6}>
            <div className="search-bar-container">
              <SearchedComponent
                handleSearch={handleSearch}
                placeholder="Lots"
                searchedValue={searchedValue}
              />
              {canAddLot ? (
                <button
                  className="create-btn"
                  onClick={() => navigate("/addUpdate-lot-management")}
                >
                  Add New Lot
                </button>
              ) : null}
            </div>
          </Grid2>
        </Grid2>

        {load ? (
          <Loader />
        ) : (
          <StyledGridComp
            rows={rowData}
            columns={columns}
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            length={rowLength}
          ></StyledGridComp>
        )}

        <Grid2
          alignItems={"end"}
          justifyContent="end"
          container
          sx={{ marginTop: "2%" }}
        >
          <Grid2 item md={6}>
            <button className="create-btn">Back</button>
          </Grid2>
        </Grid2>
      </div>
    </>
  );
};

export default LotManagement;
